import React, { forwardRef, memo, useImperativeHandle, useState } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { useSKU } from 'hooks/useSKU';

import { useAppSelector } from 'store/hooks';
import { locationSelector, washhubSelector } from 'store/slices/washhub';

import { updateItem } from 'api/items';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import { Item } from 'types/items';
import { RefType, EditItemModalProps } from './EditItemModal.props';

import EditItemModalView from './EditItemModal.view';
import { Site } from 'types/site';
import { useSites } from 'hooks/sites/useSites';

const Container = forwardRef<RefType, EditItemModalProps>((_, ref) => {
  const queryClient = useQueryClient();
  const washHubs = useAppSelector(washhubSelector);
  const selectedWashHub = useAppSelector(locationSelector);

  const [item, setItem] = useState<Item | null>(null);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { data: skus = [], isLoading: isLoadingSKU } = useSKU('item');

  const { mutate, isLoading } = useMutation(updateItem, {
    onSuccess: () => {
      successToast('Item updated successfully');

      queryClient.invalidateQueries(`fetch-items-${selectedWashHub?._id}`);

      onClose();
    },
  });

  useImperativeHandle(
    ref,
    () => ({
      onOpen: (_item) => {
        setItem(_item);

        onOpen();
      },
    }),
    [],
  );
  const _sites = useSites().data;

  const onSubmit = (values: any) => {
    values = {
      _id: item?._id,
      washHub: selectedWashHub?._id,
      sku: values?.sku,
      rfid: values?.rfid,
      size: Number(values?.size || '0'),
      type: values?.itemType,
      status: Number(values?.status || '0'),
      packageId: values?.packageId || '',
      currentVenue:
        _sites?.filter((venue: any) => venue.name === values?.venue)[0] || '',
      qrCode: values?.qrCode || '',
    };

    mutate(values);
  };

  const _props = {
    skus,
    item,
    isOpen,
    onClose,
    onSubmit,
    washHubs,
    isLoading,
    isLoadingSKU,
  };

  return <EditItemModalView {..._props} />;
});

const EditItemModal = memo(Container);

export default EditItemModal;
